// GAVION missed-call (owner request 2026-10-15): no callback on a Saturday, a Sunday, Dec 25 or Jan 1 (the LEAD's local
// date, like the calling windows). SQL twin: private.weekday_callback (supabase/schemas/55_gavion_missed_call_email.sql),
// which moves such a callback on every write; the dialer refuses those days first (quickChips, OutcomeForm).
import { addDays } from "./toronto";
import { wallToUtc, zoneParts } from "./zone";

const pad = (n: number) => String(n).padStart(2, "0");
const isoDow = (day: string): number =>
  ((new Date(`${day}T00:00:00Z`).getUTCDay() + 6) % 7) + 1;

/** True for a Saturday, a Sunday, Dec 25 or Jan 1 (YYYY-MM-DD). */
export const isNoCallbackDay = (day: string): boolean =>
  isoDow(day) >= 6 || day.endsWith("-12-25") || day.endsWith("-01-01");

/** `day` itself, or the next day that is not a Saturday, Sunday, Dec 25 or Jan 1 (YYYY-MM-DD). */
export function nextCallbackDay(day: string): string {
  let d = day;
  while (isNoCallbackDay(d)) d = addDays(d, 1);
  return d;
}

/** `at` moved to the next business day at the same wall-clock time in `tz`; unchanged on a business day. */
export function weekdayCallback(at: Date, tz: string): Date {
  const p = zoneParts(at, tz);
  const day = `${p.year}-${pad(p.month)}-${pad(p.day)}`;
  const next = nextCallbackDay(day);
  if (next === day) return at;
  const [y, m, d] = next.split("-").map(Number);
  return wallToUtc(
    Date.UTC(y, m - 1, d, p.hour, p.minute, p.second, at.getUTCMilliseconds()),
    tz,
  );
}
